import { ACCOUNT_TYPE } from "@/constants";

// 设置账号信息
export const setAccountInfo = (state, payload) => {
  state.accountInfo = payload;
};

// 设置菜单列表
export const setMenuList = (state, payload) => {
  state.supplierMenuList = payload;
};

// 得到供应商信息
export const setSupplierInfo = (state, payload) => {
  state.supplierInfo = payload;
};

export const setMerchantState = (state, payload) => {
  state.merchantState = payload;
};

// 根据页面路径判断账号类型: 0-商品供应商，1-劳动力
export const setAccountTypeByPath = (state) => {
  const pathname = window.location.pathname;
  // 兼容历史（带micro）和现在（不带micro）的路径，以及 renxiao 有无 /partner 前缀
  state.accountTypeByPath =
    /^\/renxiao|^\/partner\/renxiao|^\/micro\/lmsplat|^\/lmsplat|^\/micro\/finance\/labor|^\/finance\/labor/.test(
      pathname
    )
      ? ACCOUNT_TYPE.RENXIAO
      : ACCOUNT_TYPE.SUPPLIER;
};
